export const ACTION_BLOCK_TYPES = {
  PRODUCTS_FROM_A_TO_Z: 'PRODUCTS_FROM_A_TO_Z',
  PRODUCT_SELECTOR_LIST: 'PRODUCT_SELECTOR_LIST',
  MASTER_RANGE_PRODUCT: 'MASTER_RANGE_PRODUCT',
  DOWNLOAD_CENTER: 'DOWNLOAD_CENTER',
};

export const ICONS_BY_TYPE = {
  [ACTION_BLOCK_TYPES.PRODUCTS_FROM_A_TO_Z]: 'action_filter',
  [ACTION_BLOCK_TYPES.PRODUCT_SELECTOR_LIST]: 'product_selector',
  [ACTION_BLOCK_TYPES.MASTER_RANGE_PRODUCT]: 'box1',
  [ACTION_BLOCK_TYPES.DOWNLOAD_CENTER]: 'action_doc_new',
};
